import Icon from '@dtvgo/icon';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import { jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';

/* External */

function ViewModeButton(_ref) {
  var isFullScreenMode = _ref.isFullScreenMode,
    handleToggleFullScreen = _ref.handleToggleFullScreen,
    enterFullscreenTooltip = _ref.enterFullscreenTooltip,
    exitFullscreenTooltip = _ref.exitFullscreenTooltip;
  return /*#__PURE__*/jsx(PlayerButton, {
    className: "dtv-common-c-view-mode-button",
    onClick: handleToggleFullScreen,
    tooltip: isFullScreenMode ? exitFullscreenTooltip : enterFullscreenTooltip,
    children: /*#__PURE__*/jsx(Icon, {
      name: isFullScreenMode ? 'exit-fullscreen' : 'fullscreen'
    })
  });
}
ViewModeButton.defaultProps = {
  isFullScreenMode: false,
  handleToggleFullScreen: function handleToggleFullScreen() {},
  enterFullscreenTooltip: '',
  exitFullscreenTooltip: ''
};

export { ViewModeButton as default };
//# sourceMappingURL=ViewModeButton.js.map
